import { useState } from "react";
import { Button, Modal, Spinner } from "react-bootstrap";
import { MdBlock, MdRefresh, MdClose } from "react-icons/md";
import useEndedSelection from "../../contexts/endedSelection";
import useAuth from "../../contexts/auth";
import useNotification from "../../contexts/notification";
import { markProductsAsEnded } from "../../services/api";

export default function EndedActionBar() {
  const { selectedIds, clearSelection } = useEndedSelection();
  const { user } = useAuth();
  const { setMessage } = useNotification();
  const [confirm, setConfirm] = useState({ open: false, encerrar: true });
  const [isApplying, setIsApplying] = useState(false);

  const canManage = user && user.type && user.type !== "client";
  if (!canManage || selectedIds.length === 0) return null;

  const askConfirm = (encerrar) => {
    setConfirm({ open: true, encerrar });
  };

  const closeConfirm = () => {
    if (isApplying) return;
    setConfirm({ open: false, encerrar: true });
  };

  const applyConfirmed = async () => {
    setIsApplying(true);
    try {
      const res = await markProductsAsEnded(selectedIds, confirm.encerrar);
      const updated = res?.updatedCount ?? selectedIds.length;
      setMessage({
        error: false,
        content: confirm.encerrar
          ? `${updated} oferta(s) marcada(s) como encerrada(s).`
          : `${updated} oferta(s) reativada(s) com sucesso.`,
      });
      clearSelection();
      setConfirm({ open: false, encerrar: true });
      setTimeout(() => window.location.reload(), 800);
    } catch (e) {
      setMessage({ error: true, content: "Erro ao atualizar ofertas. Tente novamente." });
    } finally {
      setIsApplying(false);
    }
  };

  return (
    <>
      <div
        style={{
          position: "fixed",
          bottom: 24,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 2000,
          background: "#212529",
          color: "#fff",
          padding: "12px 18px",
          borderRadius: 14,
          boxShadow: "0 12px 32px rgba(0,0,0,0.35)",
          display: "flex",
          alignItems: "center",
          gap: 10,
          flexWrap: "wrap",
          maxWidth: "92vw",
        }}
      >
        <strong style={{ fontSize: "0.95rem" }}>{selectedIds.length} selecionada(s)</strong>
        <Button
          variant="secondary"
          size="sm"
          onClick={() => askConfirm(true)}
          style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
        >
          <MdBlock /> Encerrar
        </Button>
        <Button
          variant="success"
          size="sm"
          onClick={() => askConfirm(false)}
          style={{ display: "inline-flex", alignItems: "center", gap: 4 }}
        >
          <MdRefresh /> Reativar
        </Button>
        <Button
          variant="link"
          size="sm"
          onClick={clearSelection}
          style={{ color: "#fff", display: "inline-flex", alignItems: "center", gap: 4 }}
        >
          <MdClose /> Limpar
        </Button>
      </div>

      <Modal show={confirm.open} onHide={closeConfirm} centered>
        <Modal.Header closeButton={!isApplying}>
          <Modal.Title>
            {confirm.encerrar ? "Encerrar ofertas selecionadas" : "Reativar ofertas selecionadas"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="mb-2">
            {confirm.encerrar
              ? "As ofertas marcadas vão aparecer em cinza com o selo \"Encerrada\" na vitrine, e o link de compra ficará bloqueado para os clientes."
              : "As ofertas voltarão a ficar visíveis e clicáveis na vitrine."}
          </p>
          <p className="mb-0">
            <strong>{selectedIds.length}</strong> oferta(s) será(ão) {confirm.encerrar ? "encerrada(s)" : "reativada(s)"}.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={closeConfirm} disabled={isApplying}>
            Cancelar
          </Button>
          <Button
            variant={confirm.encerrar ? "secondary" : "success"}
            onClick={applyConfirmed}
            disabled={isApplying}
            style={{ display: "inline-flex", alignItems: "center", gap: 6 }}
          >
            {isApplying ? (
              <>
                <Spinner animation="border" size="sm" /> Aplicando...
              </>
            ) : (
              <>
                {confirm.encerrar ? <MdBlock /> : <MdRefresh />}
                Confirmar {confirm.encerrar ? "encerramento" : "reativação"}
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
